<template>
	<div>
		<v-row class="mt-4" no-gutters>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model.trim="$v.form.name.$model"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Nombre Ej: Minera los pelambres"
					:error-messages="nameErrors"
					@input="$v.form.name.$touch()"
					@blur="$v.form.name.$touch()"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model.trim="$v.form.rut.$model"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="RUT/Número/código Ej: 11.111.111-3"
					:error-messages="rutErrors"
					@input="$v.form.rut.$touch()"
					@blur="$v.form.rut.$touch()"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model.trim="form.cliente"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Cliente"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model.trim="form.direction"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Direccion"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-select
					class="mx-1"
					v-model="form.region"
					:items="regiones"
					:error-messages="regionError"
					item-text="region"
					item-value="region"
					dense
					solo
					filled
					outlined
					autocomplete="off"
					persistent-hint
					hint="Region"
				>
				</v-select>
			</v-col>
			<v-col cols="12" sm="6">
				<v-select
					dense
					solo
					:items="placeTypes"
					item-text="label"
					item-value="value"
					autocomplete="off"
					outlined
					filled
					persistent-hint
					hint="Tipo de lugar. Domicilio/Empresa"
					v-model="form.type"
				/>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model="form.email[0]"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Correo electrónico"
				>
				</v-text-field>
			</v-col>
		</v-row>
		<v-divider class="mb-3"></v-divider>
		<v-row>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model="form.nombreSolicitante"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Nombre solicitante Ej: Juan Pérez"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model="form.rutSolicitante"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Rut solicitante Ej: 11.111.111-3"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-select
					class="mx-1"
					v-model="form.frecuenciaCorreos"
					:items="['Mensual', 'Diario', 'Default']"
					default="Default"
					solo
					dense
					outlined
					filled
					persistent-hint
					hint="Frecuencia correos"
				></v-select>
			</v-col>
			<v-col cols="12" sm="6" v-if="form.frecuenciaCorreos !== 'Default'">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="form.horaCorreos"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							solo
							v-model="form.horaCorreos"
							persistent-hint
							hint="Hora a la que se enviaran los correos"
							readonly
							outlined
							dense
							filled
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menu"
						v-model="form.horaCorreos"
						format="24hr"
						full-width
						@click:minute="$refs.menu.save(form.horaCorreos)"
					></v-time-picker>
				</v-menu>
			</v-col>
			<!-- 
				<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model.trim="form.city"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Ciudad/comuna"
						></v-text-field>
					</v-col>  -->
			<!-- <v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model.trim="formData.name"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Servicio prestado Ej: Visita"
					:disabled="loading"
					:error-messages="serviceErrors"
					@input="$v.formData.name.$touch()"
					@blur="$v.formData.name.$touch()"
				></v-text-field>
			</v-col>
			<v-col cols="12" sm="6">
				<v-text-field
					class="mx-1"
					v-model="formData.price"
					solo
					autocomplete="off"
					dense
					outlined
					filled
					persistent-hint
					hint="Precio Ej: 1"
					:error-messages="priceErrors"
					@input="$v.formData.price.$touch()"
					@blur="$v.formData.price.$touch()"
				></v-text-field>
			</v-col> -->
			<!-- <v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.nombreSolicitante"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Nombre solicitante Ej: Juan Pérez"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.rutSolicitante"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Rut solicitante Ej: 11.111.111-3"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.direccionSolicitante"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Dirección solicitante"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.comunaSolicitante"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Comuna solicitante"
						></v-text-field>
					</v-col>  -->
			<!-- <v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Direccion propietario"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-select
							dense
							solo
							:items="placeTypes"
							item-text="label"
							item-value="value"
							autocomplete="off"
							outlined
							filled
							persistent-hint
							hint="Tipo de lugar. Domicilio/Empresa"
							v-model="form.type"
						/>
					</v-col>
				</v-row>

				<v-row class="my-2" no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.email[0]"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Correo electrónico 1"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							class="mx-1"
							v-model="form.email[1]"
							solo
							autocomplete="off"
							dense
							outlined
							filled
							persistent-hint
							hint="Correo electrónico 2"
						></v-text-field>
					</v-col>
                -->
		</v-row>
		<v-row align="center" justify="end">
			<v-col cols="4" sm="3">
				<v-btn
					block
					small
					:loading="loading"
					class="mb-2"
					color="success"
					@click="onSubmit"
				>
					<v-icon>mdi-content-save-outline</v-icon>
					Guardar
				</v-btn>
			</v-col>
			<v-btn class="ml-2" small color="warning" @click="helpPlace = !helpPlace">
				<v-icon small>mdi-help</v-icon>
			</v-btn>
		</v-row>
		<v-row>
			<v-expand-transition>
				<v-col cols="12" v-if="helpPlace">
					<div class="pointer" @click="helpPlace = !helpPlace">
						<empty
							:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
							font-color="#6A31FF"
							height="130"
							title="¿Qué es?"
							msj="Un Establecimiento es donde podrás planificar actividades de personas. Por ejemplo; Una faena, hotel, domicilio."
						/>
						<br />
						<empty
							:background-color="$vuetify.theme.isDark ? '#6a31ff17' : '#ded1ff7d'"
							font-color="#6A31FF"
							height="130"
							title="Caso especifico de ejemplo"
							msj="Podrías planificar 3 turnos para 20 personas en una construcción, ademas del servicio de cenas y entrega de EPP"
						/>
					</div>
				</v-col>
			</v-expand-transition>
		</v-row>
	</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapMutations } from 'vuex';
import regiones from '@/assets/comunas-regiones.json';

export default {
	mixins: [validationMixin],
	props: {
		close: {
			type: Function,
			default: null,
		},
	},
	components: {
		Empty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			regiones,
			helpPlace: false,
			placeTypes: ['Empresa', 'Domicilio'],
			loading: false,
			form: {
				type: '',
				name: '',
				cliente: '',
				rut: '',
				direction: '',
				city: '',
				services: [],
				email: [],
				nombreSolicitante: '',
				rutSolicitante: '',
				direccionSolicitante: '',
				comunaSolicitante: '',
				direccionPropietario: '',
				region: '',
				horaCorreos: '',
				frecuenciaCorreos: 'Default',
			},
			formData: { name: 'Visita', price: '1' },
			menu: undefined,
		};
	},
	computed: {
		isPlaceRoute() {
			return this.$route.name == 'places';
		},
		nameErrors() {
			const errors = [];
			if (!this.$v.form.name.$dirty) return errors;
			!this.$v.form.name.required && errors.push('Nombre requerido');
			!this.$v.form.name.minLength && errors.push('Mínimo 3 caracteres de nombre');
			!this.$v.form.name.maxLength && errors.push('Máximo 100 caracteres de nombre');
			return errors;
		},
		rutErrors() {
			const errors = [];
			if (!this.$v.form.rut.$dirty) return errors;
			!this.$v.form.rut.required && errors.push('RUT requerido');
			return errors;
		},
		regionError() {
			const errors = [];
			if (!this.$v.form.region.$dirty) return errors;
			!this.$v.form.region.required && errors.push('La región es requerida');
			return errors;
		},
		serviceErrors() {
			const errors = [];
			if (!this.$v.formData.name.$dirty) return errors;
			!this.$v.formData.name.required && errors.push('Servicio requerido');
			!this.$v.formData.name.minLength && errors.push('Mínimo 3 caracteres del servicio');
			!this.$v.formData.name.maxLength && errors.push('Máximo 50 caracteres del servicio');
			return errors;
		},
		priceErrors() {
			const errors = [];
			if (!this.$v.formData.price.$dirty) return errors;
			!this.$v.formData.price.required && errors.push('Precio requerido');
			this.formData.price.includes('.') &&
				errors.push('No debe llevar puntos o coma el prercio');
			this.formData.price.includes(',') &&
				errors.push('No debe llevar puntos o coma el precio');
			return errors;
		},
	},
	methods: {
		duplicateInfo(type) {
			const types = {
				city: () => {
					this.form.comunaSolicitante = this.form.city;
				},
				direction: () => {
					this.form.direccionSolicitante = this.form.direction;
					this.form.direccionPropietario = this.form.direction;
				},
				name: () => {
					this.form.nombreSolicitante = this.form.name;
					this.form.rutSolicitante = this.form.rut;
				},
			};
			types[type]();
		},
		async onSubmit() {
			this.$v.$touch();
			if (
				!this.$v.$invalid &&
				(!this.formData.price.includes('.') || this.formData.price.includes(','))
			) {
				this.loading = true;
				this.form.services.push(this.formData);
				await this.createPlace(this.form);
				await this.fetchPlace();
				this.setHasNewPlace();
				this.close();
				this.clearInputs();
				this.$v.$reset();
				this.loading = false;
				this.helpPlace = false;
			}
		},
		clearInputs() {
			this.form = {
				name: '',
				cliente: '',
				rut: '',
				direction: '',
				city: '',
				region: '',
				services: [],
				email: [],
			};
			this.formData = { name: 'Visita', price: '1' };
			this.errors = false;
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			createPlace: 'Place/createPlace',
		}),
		...mapMutations({
			setHasNewPlace: 'Place/setHasNewPlace',
		}),
	},
	validations: {
		form: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
			},
			rut: {
				required,
			},
			region: {
				required,
			},
		},
		formData: {
			name: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(50),
			},
			price: {
				required,
			},
		},
	},
};
</script>
